import CheckBoxField from './component'

export default CheckBoxField
